import React, { Component } from 'react';

import './SupportPane.css';

export default class SupportPane extends Component {
  render() {
    const { title, description } = this.props;
    return (
      <div className="SupportPane">
        <div className="SupportPaneTitle">{ title }</div>
        <div className="SupportPaneDescription">{ description }</div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SupportDashboard/SupportBody/SupportPane/SupportPane.js